"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "cards-filter" };
const _hoisted_2 = {
    key: 0,
    class: "cards-filter-results-cont"
};
const _hoisted_3 = {
    key: 0,
    class: "create-game-expansion-icon expansion-icon-prelude",
    title: "This card is a prelude"
};
const _hoisted_4 = {
    key: 1,
    class: "create-game-expansion-icon expansion-icon-ceo",
    title: "This card is a CEO"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = { class: "cards-filter-input" };
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
    key: 0,
    class: "cards-filter-suggest"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 0,
    class: "create-game-expansion-icon expansion-icon-prelude",
    title: "This card is a Prelude"
};
const _hoisted_11 = {
    key: 1,
    class: "create-game-expansion-icon expansion-icon-ceo",
    title: "This card is a CEO"
};
const _hoisted_12 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [
            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.title), 1)
        ])), [
            [_directive_i18n]
        ]),
        (_ctx.selected.length)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.selected, (cardName) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "cards-filter-result",
                        key: cardName
                    }, [
                        (0, vue_1.createElementVNode)("label", null, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(cardName) + " ", 1),
                            (_ctx.isPrelude(cardName))
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", _hoisted_3))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.isCEO(cardName))
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", _hoisted_4))
                                : (0, vue_1.createCommentVNode)("", true),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.expansions(cardName), (expansion) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", {
                                    key: expansion,
                                    class: (0, vue_1.normalizeClass)(`create-game-expansion-icon expansion-icon-${expansion}`),
                                    title: expansion
                                }, null, 10, _hoisted_5));
                            }), 128))
                        ]),
                        (0, vue_1.createVNode)(_component_AppButton, {
                            size: "small",
                            type: "close",
                            onClick: ($event) => (_ctx.removeCard(cardName))
                        }, null, 8, ["onClick"])
                    ]));
                }), 128))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_6, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    ref: "filter",
                    class: "form-input",
                    placeholder: _ctx.$t(_ctx.hint),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchTerm) = $event))
                }, null, 8, _hoisted_7), [
                    [vue_1.vModelText, _ctx.searchTerm]
                ])
            ]),
            (_ctx.searchMatches.length)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.searchMatches, (cardName) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "cards-filter-suggest-item",
                            key: cardName
                        }, [
                            (0, vue_1.createElementVNode)("a", {
                                href: "#",
                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.addCard(cardName)), ["prevent"])
                            }, [
                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(cardName) + " ", 1),
                                (_ctx.isPrelude(cardName))
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", _hoisted_10))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.isCEO(cardName))
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", _hoisted_11))
                                    : (0, vue_1.createCommentVNode)("", true),
                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.expansions(cardName), (expansion) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", {
                                        key: expansion,
                                        class: (0, vue_1.normalizeClass)(`create-game-expansion-icon expansion-icon-${expansion}`),
                                        title: expansion
                                    }, null, 10, _hoisted_12));
                                }), 128))
                            ], 8, _hoisted_9)
                        ]));
                    }), 128))
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ]));
}
